/**
 * URL-safe base64, both directions, unicode-safe.
 *
 * Browser primitives rather than `Buffer`, so this is usable from the embed bundle that runs on a
 * supplier's page as well as from the app. `lib/utils/redirect-token.ts` keeps its own `Buffer`
 * path: it compresses first and only ever runs on the server.
 */

/** `btoa` takes one byte per character, so UTF-8 has to be spelled out before it. */
export function encodeBase64Url(text: string): string {
  const bytes = new TextEncoder().encode(text);
  let binary = '';
  for (const byte of bytes) binary += String.fromCharCode(byte);
  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

/** Throws on input that isn't base64, which callers reading untrusted values must handle. */
export function decodeBase64UrlBytes(value: string): Uint8Array<ArrayBuffer> {
  const binary = atob(value.replace(/-/g, '+').replace(/_/g, '/'));
  return Uint8Array.from(binary, character => character.charCodeAt(0));
}

export function decodeBase64Url(value: string): string {
  return new TextDecoder().decode(decodeBase64UrlBytes(value));
}
